import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { fmtMoney } from "@/lib/api";

export const SavingsChart = ({ recommended, inhouse }) => {
  const data = [
    { name: "Rendeavored", value: recommended, fill: "#1E6BFF" },
    { name: "In-house (US)", value: inhouse, fill: "#66B2FF" },
  ];
  return (
    <div style={{ width: "100%", height: 240 }} data-testid="savings-chart">
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" vertical={false} />
          <XAxis dataKey="name" stroke="rgba(255,255,255,0.55)" tick={{ fontSize: 12 }} />
          <YAxis
            stroke="rgba(255,255,255,0.55)"
            tick={{ fontSize: 12 }}
            tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`}
          />
          <Tooltip
            cursor={{ fill: "rgba(255,255,255,0.04)" }}
            contentStyle={{
              backgroundColor: "#121A2E",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 12,
              color: "#fff",
            }}
            formatter={(v) => [fmtMoney(v) + "/mo", "Est. cost"]}
          />
          <Bar dataKey="value" radius={[8, 8, 0, 0]} maxBarSize={90}>
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SavingsChart;
